<template>
  <a-button
    type="text"
    @click="
      handleShowModal();
      $emit('click');
    "
    :disabled="item.status === 2"
    :class="item.status === 2 ? 'button-result-edit' : ''"
  >
    <template #icon>
      <PlusOutlined type="link" size="small" />
    </template>

    Agregar nuevo resultado
  </a-button>
  <a-drawer
    :visible="visible"
    width="400px"
    :mask-closable="false"
    centered
    :closable="false"
    :keyboard="false"
    @close="handleConfirmationClose"
  >
    <div class="container__title">
      <div>
        <span class="title__drawer">Agregar nuevo resultado</span>
        <a-tooltip>
          <template #title
            >Los resultados pertenecen a un grupo y especifican con más detalle de que trata una
            llamada o interacción. Por ejemplo, para un grupo de “Contacto Directo”, puedes crear un
            resultado “Contacto con titular de la línea”.</template
          >
          <InfoCircleOutlined />
        </a-tooltip>
      </div>
      <CloseOutlined @click="handleConfirmationClose" />
    </div>
    <di class="title">
      <h4>Grupo:</h4>
      <h5>{{ item.name }}</h5>
    </di>

    <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <a-form-item label="Nombre del resultado" name="name">
        <a-input
          v-model:value="formState.name"
          placeholder="Escribir nombre del resultado aquí..."
        />
      </a-form-item>

      <a-form-item name="code">
        <template #label>
          <span class="label">
            Código de integración
            <a-tooltip>
              <template v-slot:title>
                Código de identificación para exportaciones o integraciones
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </span>
        </template>
        <a-input v-model:value="formState.code" placeholder="Escribir código aquí..." />
      </a-form-item>
    </a-form>

    <fixed-footer
      confirmText="Agregar resultado"
      @onCancel="handleCancel"
      @onConfirm="handleOk"
      cancelText="Cancelar"
    />
  </a-drawer>
</template>

<script>
import {
  InfoCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons-vue";
import { defineComponent, reactive, ref, toRaw, createVNode } from "vue";
import FixedFooter from "@/app/shared/components/sections/FixedFooter.vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    InfoCircleOutlined,
    FixedFooter,
    PlusOutlined,
    CloseOutlined,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  setup() {
    const formRef = ref();
    const formState = reactive({
      name: "",
      code: "",
    });
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
    };

    return {
      formRef,
      formState,
      rules,
    };
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleOk() {
      this.formRef.validateFields().then(() => {
        let values = toRaw(this.formState);
        this.$emit("push", {
          ...values,
          pdp: values?.pdp || false,
          is_sale: values?.is_sale || false,
          is_schedule: values?.is_schedule || false,
          status: 1,
          children: [],
          type: "result",
          is_expanded: true,
          order: this.item.order + "." + (this.item.children.length + 1),
          group: this.item.id,
        });
        this.visible = false;
        this.formRef.resetFields();
      });
    },
    handleShowModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de descartar cambios?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Descartar",
        cancelText: "Cancelar",
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.title
  margin-bottom: 24px

.link
  text-decoration: underline
.button-result-edit
  opacity: 0.4

.title__drawer
  margin-right: 5px
  font-size: 16px
  font-weight: 600

.container__title
  height: 34px
  border-bottom: 1px solid #D4D4D4
  display: flex
  justify-content: space-between
  margin-bottom: 20px
  margin-top: -5px
</style>
